import { SVGProps } from 'react';

function ClockIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width}
      height={props.height}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M6 .667C2.792.667.167 3.292.167 6.5S2.792 12.333 6 12.333s5.833-2.625 5.833-5.833S9.208.667 6 .667Zm0 10.5A4.673 4.673 0 0 1 1.333 6.5 4.673 4.673 0 0 1 6 1.833 4.673 4.673 0 0 1 10.667 6.5 4.673 4.673 0 0 1 6 11.167Zm.292-7.584h-.875v3.5L8.45 8.95l.467-.758-2.625-1.575V3.583Z'
        fill={props.fill}
      />
    </svg>
  );
}

export default ClockIcon;
